export const DiscomfortLevelEnum = Object.freeze({
    None: "NONE",
    Slight: "SLIGHT",
    Moderate: "MODERATE",
    Severe: "SEVERE",
    Extreme: "EXTREME"
})
